export default __webpack_public_path__ + "static/media/7A2_1980-29-1.b81f077f.png";